import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Register from "@/pages/Register";
import Activate from "@/pages/Activate";
import Dashboard from "@/pages/Dashboard";
import Beneficiaries from "@/pages/Beneficiaries";
import Activity from "@/pages/Activity";
import NetWorth from "@/pages/NetWorth";
import Banking from "@/pages/Banking";
import MapPage from "@/pages/MapPage";
import LevelUp from "@/pages/LevelUp";
import Budget from "@/pages/Budget";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import Support from "@/pages/Support";
import BabyFunds from "@/pages/BabyFunds";
import AdminTickets from "@/pages/AdminTickets";
import AdminWaitlist from "@/pages/AdminWaitlist";
import AdminCardPayouts from "@/pages/AdminCardPayouts";
import Statements from "@/pages/Statements";
import Inventory from "@/pages/Inventory";
import ApproveOrder from "@/pages/ApproveOrder";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import PublicProfile from "@/pages/PublicProfile";
import WalkthroughModal from "@/components/WalkthroughModal";
import DobGate from "@/components/DobGate";
import ConfirmBeneficiary from "@/pages/ConfirmBeneficiary";
import { Toaster } from "sonner";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/u/:username" element={<PublicProfile />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/confirm-beneficiary/:token" element={<ConfirmBeneficiary />} />
          <Route path="/approve-order/:token" element={<ApproveOrder />} />
          <Route path="/activate" element={<ProtectedRoute><Activate /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute requirePaid><Dashboard /></ProtectedRoute>} />
          <Route path="/inventory" element={<ProtectedRoute requirePaid><Inventory /></ProtectedRoute>} />
          <Route path="/beneficiaries" element={<ProtectedRoute requirePaid><Beneficiaries /></ProtectedRoute>} />
          <Route path="/activity" element={<ProtectedRoute requirePaid><Activity /></ProtectedRoute>} />
          <Route path="/networth" element={<ProtectedRoute requirePaid><NetWorth /></ProtectedRoute>} />
          <Route path="/banking" element={<ProtectedRoute requirePaid><Banking /></ProtectedRoute>} />
          <Route path="/map" element={<ProtectedRoute requirePaid><MapPage /></ProtectedRoute>} />
          <Route path="/level-up" element={<ProtectedRoute requirePaid><LevelUp /></ProtectedRoute>} />
          <Route path="/budget" element={<ProtectedRoute requirePaid><Budget /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
          <Route path="/support" element={<ProtectedRoute><Support /></ProtectedRoute>} />
          <Route path="/baby-funds" element={<ProtectedRoute requirePaid><BabyFunds /></ProtectedRoute>} />
          <Route path="/admin/tickets" element={<ProtectedRoute><AdminTickets /></ProtectedRoute>} />
          <Route path="/admin/waitlist" element={<ProtectedRoute><AdminWaitlist /></ProtectedRoute>} />
          <Route path="/admin/cash-out" element={<ProtectedRoute><AdminCardPayouts /></ProtectedRoute>} />
          <Route path="/statements" element={<ProtectedRoute><Statements /></ProtectedRoute>} />
        </Routes>
        <DobGate />
        <WalkthroughModal />
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}

export default App;
